(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@redux-saga/delay-p"), require("redux-saga"), require("redux-saga/effects"), require("reselect"));
	else if(typeof define === 'function' && define.amd)
		define(["@redux-saga/delay-p", "redux-saga", "redux-saga/effects", "reselect"], factory);
	else if(typeof exports === 'object')
		exports["ReduxSagaRequests"] = factory(require("@redux-saga/delay-p"), require("redux-saga"), require("redux-saga/effects"), require("reselect"));
	else
		root["ReduxSagaRequests"] = factory(root[undefined], root["ReduxSaga"], root["ReduxSaga.effects"], root["Reselect"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__redux_saga_delay_p__, __WEBPACK_EXTERNAL_MODULE_redux_saga__, __WEBPACK_EXTERNAL_MODULE_redux_saga_effects__, __WEBPACK_EXTERNAL_MODULE_reselect__) {
return 